__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "OffMgmtVnext";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@angular/cdk/a11y", "21.2.14", () => (Promise.all([__webpack_require__.e("OffMgmtVnext-vendor-cdk"), __webpack_require__.e("OffMgmtVnext-common")]).then(() => (() => (__webpack_require__(4908))))));
			register("@angular/common/http", "21.2.21", () => (Promise.all([__webpack_require__.e("OffMgmtVnext-vendor-common"), __webpack_require__.e("OffMgmtVnext-common")]).then(() => (() => (__webpack_require__(467))))));
			register("rxjs/operators", "7.8.2", () => (Promise.all([__webpack_require__.e("OffMgmtVnext-vendor-rxjs"), __webpack_require__.e("webpack_sharing_consume_default_tslib_tslib")]).then(() => (() => (__webpack_require__(7432))))));
			register("tslib", "2.8.1", () => (__webpack_require__.e("node_modules_tslib_tslib_es6_mjs").then(() => (() => (__webpack_require__(7462))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};